// pkg125 — admin prop: Client Modules workspace renders this page with adminApi I/O; Send-to-Attorney hidden in admin mode (D-124e) — delivered 2026-07-27
// pkg72 — LawMighty retheme: brand hex sweep (#1a1a1a→#0F1838 NAVY_DEEP, #0f0f0f→#0A1028, #f8f8f8→#F5F1E8 CREAM, #c0392b→#B85042 TERRA) — delivered 2026-07-12
import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { adminApi } from '../utils/adminApi'; // pkg125 — admin mode
import { useFirmSettings } from '../contexts/FirmSettingsContext';

const EXPERT_TYPES = [
  'CPA / Accountant', 'Forensic Accountant', 'Business Appraiser',
  'Real Estate Appraiser', 'Realtor / Real Estate Agent',
  'Therapist / Counselor', 'Psychologist', 'Psychiatrist',
  'Medical Doctor / Physician', 'Pediatrician', 'Vocational Expert',
  'Financial Advisor', 'Actuary', 'Other',
];

const EMPTY_GENERAL = { name: '', phone: '', email: '', address: '', testimony: '' };
const EMPTY_EXPERT  = { name: '', type: '', phone: '', email: '', address: '', testimony: '' };

function WitnessForm({ witness, onChange, isExpert, onCancel, onSave }) {
  function set(key, val) { onChange({ ...witness, [key]: val }); }
  return (
    <div style={{ background: '#F5F1E8', border: '1px solid #ddd', borderRadius: 6, padding: 16, marginBottom: 12 }}>
      <div className="form-row">
        <div className="form-group">
          <label>Full Name</label>
          <input type="text" value={witness.name} onChange={e => set('name', e.target.value)} placeholder="First and last name" />
        </div>
        {isExpert ? (
          <div className="form-group">
            <label>Area of Expertise / Role</label>
            <select value={witness.type} onChange={e => set('type', e.target.value)}>
              <option value="">— Select —</option>
              {EXPERT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
        ) : (
          <div className="form-group">
            <label>Phone Number</label>
            <input type="tel" value={witness.phone} onChange={e => set('phone', e.target.value)} placeholder="(423) 555-0100" />
          </div>
        )}
      </div>
      {isExpert && (
        <div className="form-group">
          <label>Phone Number</label>
          <input type="tel" value={witness.phone} onChange={e => set('phone', e.target.value)} placeholder="(423) 555-0100" />
        </div>
      )}
      <div className="form-row">
        <div className="form-group">
          <label>Email Address</label>
          <input type="email" value={witness.email} onChange={e => set('email', e.target.value)} placeholder="witness@email.com" />
        </div>
        <div className="form-group">
          <label>Mailing Address</label>
          <input type="text" value={witness.address} onChange={e => set('address', e.target.value)} placeholder="123 Main St, Chattanooga, TN 37402" />
        </div>
      </div>
      <div className="form-group">
        <label>What may this {isExpert ? 'expert' : 'witness'} testify to?</label>
        <textarea value={witness.testimony} onChange={e => set('testimony', e.target.value)} style={{ minHeight: 70 }}
          placeholder={isExpert
            ? 'e.g. Forensic accounting — analysis of marital income and expenses'
            : 'e.g. Observed the parties at family events, can testify regarding parenting conduct'} />
      </div>
      <div className="btn-row">
        <button className="btn" onClick={onCancel}>Cancel</button>
        <button className="btn btn-primary" onClick={onSave}>Save Witness</button>
      </div>
    </div>
  );
}

function WitnessTable({ witnesses, onEdit, onDelete, isExpert }) {
  if (!witnesses.length) return (
    <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#888', fontStyle: 'italic', margin: '8px 0 16px' }}>
      No {isExpert ? 'expert' : 'general'} witnesses added yet.
    </p>
  );
  return (
    <div className="table-wrap" style={{ marginBottom: 16 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'Arial, sans-serif' }}>
        <thead>
          <tr style={{ background: '#0F1838', color: '#fff' }}>
            <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600 }}>Name</th>
            {isExpert && <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600 }}>Expertise</th>}
            <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600 }}>Phone</th>
            <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600 }}>Email</th>
            <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: 600 }}>Expected Testimony</th>
            <th style={{ padding: '8px 10px', textAlign: 'center', fontWeight: 600, width: 120 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {witnesses.map((w, i) => (
            <tr key={i} style={{ borderBottom: '1px solid #eee', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
              <td style={{ padding: '8px 10px', fontWeight: 500 }}>{w.name || '—'}</td>
              {isExpert && <td style={{ padding: '8px 10px', color: '#555' }}>{w.type || '—'}</td>}
              <td style={{ padding: '8px 10px', color: '#555' }}>{w.phone || '—'}</td>
              <td style={{ padding: '8px 10px', color: '#555' }}>{w.email || '—'}</td>
              <td style={{ padding: '8px 10px', color: '#555', maxWidth: 220 }}>
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={w.testimony}>
                  {w.testimony || '—'}
                </div>
              </td>
              <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                  <button onClick={() => onEdit(i)} style={{ background: 'none', border: '1px solid #0F1838', borderRadius: 3, padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>Edit</button>
                  <button onClick={() => onDelete(i)} style={{ background: 'none', border: '1px solid #B85042', color: '#B85042', borderRadius: 3, padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontFamily: 'Arial, sans-serif' }}>Delete</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// pkg125 — `admin` prop ({ clientId }): rendered by the Client Modules
// workspace with adminApi I/O; Send-to-Attorney hidden (D-124e).
export default function WitnessPage({ admin = null }) {
  const { firm } = useFirmSettings();
  const io = admin ? {
    get:  () => adminApi.getClientWitnesses(admin.clientId),
    save: (data) => adminApi.saveClientWitnesses(admin.clientId, data),
  } : {
    get:  () => api.getWitnesses(),
    save: (data) => api.saveWitnesses(data),
  };
  const [general, setGeneral]   = useState([]);
  const [expert,  setExpert]    = useState([]);
  const [loading, setLoading]   = useState(true);
  const [saving,  setSaving]    = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [status,  setStatus]    = useState('');
  const [error,   setError]     = useState('');
  const [editing, setEditing]   = useState(null); // { type, index, data }
  const [addingGeneral, setAddingGeneral] = useState(false);
  const [addingExpert,  setAddingExpert]  = useState(false);
  const [newGeneral, setNewGeneral] = useState({ ...EMPTY_GENERAL });
  const [newExpert,  setNewExpert]  = useState({ ...EMPTY_EXPERT });

  useEffect(() => {
    io.get().then(rec => {
      if (rec?.data?.general?.length) setGeneral(rec.data.general);
      if (rec?.data?.expert?.length)  setExpert(rec.data.expert);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const data = { general, expert };

  async function handleSave() {
    setSaving(true); setStatus(''); setError('');
    try { await io.save(data); setStatus('Progress saved.'); }
    catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  async function handleSubmit() {
    setSubmitting(true); setStatus(''); setError('');
    try { await api.submitWitnesses(data); setStatus('Witness list sent to your attorney.'); }
    catch (err) { setError(err.message); }
    finally { setSubmitting(false); }
  }

  if (loading) return <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', color: '#888' }}>Loading...</div>;

  return (
    <div>
      <h1 className="page-title">Witness List</h1>
      <p className="page-subtitle">
        List people you may call as witnesses at trial. Your attorney will review and advise on which witnesses to call.
        You can update and resend this list at any time.
      </p>

      {status && <div className="alert alert-success">{status}</div>}
      {error  && <div className="alert alert-error">{error}</div>}

      {/* ── GENERAL WITNESSES ─────────────────────────────────────────── */}
      <div className="section-head">General Witnesses</div>
      <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginBottom: 12 }}>
        People with personal knowledge of the facts — friends, family, neighbors, coworkers, teachers, etc.
      </p>

      {editing?.type === 'general' && (
        <WitnessForm witness={editing.data} isExpert={false}
          onChange={d => setEditing(p => ({ ...p, data: d }))}
          onCancel={() => setEditing(null)}
          onSave={() => { setGeneral(prev => prev.map((w, i) => i === editing.index ? editing.data : w)); setEditing(null); }} />
      )}

      <WitnessTable witnesses={general} isExpert={false}
        onEdit={i => setEditing({ type: 'general', index: i, data: { ...general[i] } })}
        onDelete={i => setGeneral(prev => prev.filter((_, idx) => idx !== i))} />

      {addingGeneral ? (
        <WitnessForm witness={newGeneral} isExpert={false}
          onChange={setNewGeneral}
          onCancel={() => { setAddingGeneral(false); setNewGeneral({ ...EMPTY_GENERAL }); }}
          onSave={() => { setGeneral(prev => [...prev, { ...newGeneral }]); setNewGeneral({ ...EMPTY_GENERAL }); setAddingGeneral(false); }} />
      ) : (
        <button className="btn btn-sm" onClick={() => setAddingGeneral(true)} style={{ marginBottom: 24 }}>
          + Add General Witness
        </button>
      )}

      {/* ── EXPERT WITNESSES ──────────────────────────────────────────── */}
      <div className="section-head">Expert Witnesses</div>
      <p style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: '#555', marginBottom: 12 }}>
        Professionals who may provide expert opinion testimony — CPAs, appraisers, therapists, doctors, etc.
      </p>

      {editing?.type === 'expert' && (
        <WitnessForm witness={editing.data} isExpert={true}
          onChange={d => setEditing(p => ({ ...p, data: d }))}
          onCancel={() => setEditing(null)}
          onSave={() => { setExpert(prev => prev.map((w, i) => i === editing.index ? editing.data : w)); setEditing(null); }} />
      )}

      <WitnessTable witnesses={expert} isExpert={true}
        onEdit={i => setEditing({ type: 'expert', index: i, data: { ...expert[i] } })}
        onDelete={i => setExpert(prev => prev.filter((_, idx) => idx !== i))} />

      {addingExpert ? (
        <WitnessForm witness={newExpert} isExpert={true}
          onChange={setNewExpert}
          onCancel={() => { setAddingExpert(false); setNewExpert({ ...EMPTY_EXPERT }); }}
          onSave={() => { setExpert(prev => [...prev, { ...newExpert }]); setNewExpert({ ...EMPTY_EXPERT }); setAddingExpert(false); }} />
      ) : (
        <button className="btn btn-sm" onClick={() => setAddingExpert(true)} style={{ marginBottom: 24 }}>
          + Add Expert Witness
        </button>
      )}

      <div className="btn-row">
        <button className="btn" onClick={handleSave} disabled={saving}>
          {saving ? <><span className="spinner" />Saving...</> : 'Save Progress'}
        </button>
        {!admin && (
          <button className="btn btn-primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? <><span className="spinner" />Sending...</> : 'Send to Attorney'}
          </button>
        )}
      </div>
      {!admin && (
        <p style={{ fontSize: 12, color: '#888', fontFamily: 'Arial, sans-serif', marginTop: 12 }}>
          Sending emails your current witness list to {firm.client_contact_email || 'the firm'}. You can update and resend at any time.
        </p>
      )}
    </div>
  );
}
